/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_cost_management': {
    width: 22,
    height: 16,
    viewBox: '0 0 22 16',
    data: '<defs><path pid="0" d="M18.014 8.705A11.15 11.15 0 0 1 23 18h-2.933a8.202 8.202 0 0 0-3.528-6.74l-2.549 4.414-2.54-1.466 2.398-4.154A7.943 7.943 0 0 0 12 9.837c-4.455 0-8.067 3.688-8.067 8.163H1C1 11.897 5.925 6.89 12 6.89c1.174 0 2.306.188 3.367.533L17.343 4l2.54 1.467-1.869 3.238zM11.5 20a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" id="svgicon_icon_service_cost_management_a"/></defs><g transform="translate(-1 -4)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_cost_management_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_cost_management_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_cost_management_a"/><g mask="url(#svgicon_icon_service_cost_management_b)" _fill="#5D8BF8"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_cost_management.js